import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Styled from 'app/features/couponCampaign/landing/components/HeroBlockDark.styled';
import CouponProductCta from 'app/features/couponCampaign/landing/components/CouponProductCta';
import Heading from 'app/components/layout/Heading.styled';
import Perks from 'app/features/couponCampaign/landing/components/Perks';
import Text from 'app/components/layout/Text.styled';
import breakPoints from 'app/styles/constants/breakpoints';
import StackedLayout from 'app/components/layout/StackedLayout';
import connect from 'app/libs/connect';
import { heroBlockDarkProps } from 'app/features/couponCampaign/landing/selectors';
import LegalText from 'app/features/couponCampaign/landing/components/LegalText';

const { widthSmall } = breakPoints;

const UI = ({
  partnersImage,
  topLogo,
  titleKey,
  subTitleKey,
  bottomLogo,
  legalText,
}) => (
  <Styled.HeroBlockDarkWrapper>
    <StackedLayout.ContentBlock isContained>
      <Styled.HeroBlockDark>
        <Styled.Picture>
          <source
            media={`(${widthSmall})`}
            srcSet={partnersImage.desktopImageUrl}
          />
          <Styled.PartnersImage
            src={partnersImage.mobileImageUrl}
            alt="background"
          />
        </Styled.Picture>
        <Styled.UpsellWrapper>
          <Styled.TopLogo src={topLogo} alt="logo" />
          <Heading size="m" as={Styled.Title}>
            <FormattedMessage id={titleKey} />
          </Heading>
          <Text size="l" as={Styled.SubTitle}>
            <FormattedMessage id={subTitleKey} />
          </Text>
          <Styled.ButtonHolder>
            <CouponProductCta isWide isWideOnMobile={false}>
              <FormattedMessage id="coupon_landing_freetrial_heroblock_dark_button_testpartner_v1" />
            </CouponProductCta>
          </Styled.ButtonHolder>
          <LegalText legalText={legalText} as={Styled.LegalText} />
          <Styled.BottomLogo src={bottomLogo} alt="logo" />
        </Styled.UpsellWrapper>
      </Styled.HeroBlockDark>
      <Perks titleId="coupon_landing_perks_dark_title" />
    </StackedLayout.ContentBlock>
  </Styled.HeroBlockDarkWrapper>
);

UI.propTypes = {
  partnersImage: PropTypes.shape({
    mobileImageUrl: PropTypes.string.isRequired,
    desktopImageUrl: PropTypes.string.isRequired,
  }).isRequired,
  topLogo: PropTypes.string.isRequired,
  titleKey: PropTypes.string.isRequired,
  subTitleKey: PropTypes.string.isRequired,
  legalText: PropTypes.shape({
    tosLink: PropTypes.string.isRequired,
    privacyLink: PropTypes.string.isRequired,
    textKey: PropTypes.string.isRequired,
  }).isRequired,
  bottomLogo: PropTypes.string.isRequired,
};

UI.displayName = 'CouponCampaign HeroBlock';

const HeroBlockDark = connect(heroBlockDarkProps)(UI);

export { UI };

export default HeroBlockDark;
